export default __webpack_public_path__ + "static/media/6wk-running.e222d30f.jpg";